import { render, staticRenderFns } from "./ModalCentered.vue?vue&type=template&id=9d6db2d4&scoped=true"
import script from "./ModalCentered.vue?vue&type=script&lang=js"
export * from "./ModalCentered.vue?vue&type=script&lang=js"
import style0 from "./ModalCentered.vue?vue&type=style&index=0&id=9d6db2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6db2d4",
  null
  
)

export default component.exports